import React from 'react';
import StatusMetersPage from './StatusMetersPage';

export default function MetersInstalled() {
  return (
    <StatusMetersPage
      status="All"
      title="Meter Installed"
      showViewMore
    />
  );
}
